import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import SobreMi from '../views/sobreMi.vue'
import Trabajo from '../views/Trabajos.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'inicio',
    component: Home
  },
  {
    path: '/sobre_mi',
    name: 'sobre_mi',
    component: SobreMi
  },
  {
    path: '/portafolio',
    name: 'portafolio',
    component: Trabajo
  }
  //{ path: '*', component: Portafilio }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})
export default router
